import { IPageProps } from 'portal/src/layouts/LayoutPreference/layoutTypes';
import Page from 'portal/src/layouts/Page';

const AdministrationPage = (props: IPageProps) => <Page {...props} />;

export default AdministrationPage;
